import { ref, onMounted } from 'vue'

export const useMobileDetection = () => {
  const isIos = ref<boolean>(false)
  const isMobile = ref<boolean>(false)

  onMounted(() => {
    const userAgent = navigator.userAgent
    isIos.value =
      userAgent.match(/iphone|ipad|ipod/i) !== null ||
      (userAgent.indexOf('Mac') !== -1 && 'ontouchend' in document)
    isMobile.value = isIos.value || userAgent.match(/android/i) !== null
  })

  return { isIos, isMobile }
}
